import useWindowDimensions, { useIsMobile } from './windowDimensions';

export default useWindowDimensions;
export { useIsMobile };
